<template>
  <div>
    <v-dialog v-model="open" max-width="600px" persistent>
      <v-card>
        <v-toolbar elevation="0">
          <v-card-title class="ml-0 pl-1">
            {{ title }}
          </v-card-title>

          <v-spacer />

          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <slot></slot>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer></v-spacer>
          <confirm-modal
            v-if="showCancelAction"
            :loading="loadingCancel" text action-text="Cancelar"
            action-color="error" :action="cancel" title="Tem certeza?"
            description="Essa ação não poderá ser desfeita"
          />
          <v-btn
            color="primary"
            text
            @click="goToTask"
          >
            Ver tarefa
          </v-btn>
          <v-btn
            v-if="showExecuteAction"
            :loading="loadingExecute"
            color="primary"
            text
            @click="execute"
          >
            Executar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
        v-model="snackbar.show"
        timeout="3000"
        :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import {handleResponseError} from '@/api/handleError'
import ConfirmModal from '@/components/ConfirmModal'

export default {
  name: "ScheduleInfoModal",
  props: {
    id: {
      type: Number,
      required: true
    },
    showExecuteAction: Boolean,
    showCancelAction: Boolean,
    open: Boolean,
    title: {
      type: String,
      required: true
    },
    onExecuteTask: {
      type: Function,
      required: true
    },
    onCancelTask: {
      type: Function,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    }
  },
  methods: {
    goToTask() {
      window.open('/task/'+this.id)
    },
    close: function() {
      this.onClose()
    },
    execute: async function () {
      this.loadingExecute = true
      await this.$store.dispatch('tasks/force', this.id).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao executar o agendamento.')
        this.showNotification(message, 'red darken-2')
        this.loadingExecute = false
      })
      this.loadingExecute = false
      this.onExecuteTask()
    },
    cancel: async function () {
      this.loadingCancel = true
      await this.$store.dispatch('tasks/cancel', this.id).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao cancelar o agendamento.')
        this.showNotification(message, 'red darken-2')
        this.loadingExecute = false
      })
      this.loadingCancel = false
      this.onCancelTask()
    },
    showNotification: function(message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
  },
  components: {
    ConfirmModal
  },
  data: () => ({
    loadingExecute: false,
    loadingCancel: false,
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
  })
}
</script>

<style scoped>

</style>
